const eventsSearchBar = document.querySelector('.em-search.em-events-search');

const addSubmitEventButton = () => {

    const submitEventBtn = document.createElement('a');
    const btnText = document.createTextNode('Submit an event');
    submitEventBtn.appendChild(btnText);
    submitEventBtn.href = '/events/your-events/?action=edit';
    submitEventBtn.classList.add('button', 'em-search-submit', 'button-primary');
    eventsSearchBar.appendChild(submitEventBtn);

};

if (eventsSearchBar) {

    addSubmitEventButton();

}
